import WatchTutorialsButton from './WatchTutorialsButton';

export default WatchTutorialsButton;
